import React from "react";
import { Pin } from "@vis.gl/react-google-maps";
import { Box } from "@mui/material";
const { useState, useEffect } = React;

function getPinStyle(org) {
    const pinColor = org.pin_color ? org.pin_color : '#ff0000'; // default red
    const borderColor = '#000'; // default dark red

    console.log(`getPinStyle org=`, org, `pinColor=`, pinColor);

    if (org.type !== undefined && (org.type == 'school' || org.type == 'primary')) {
        return {
            background: pinColor,
            borderColor: borderColor,
            glyphColor: "#ffffff"
        }
    } else {
        return {
            background: "#0000ff",
            borderColor: "#0000b0",
            glyphColor: "#ffffff"
        }
    }
}

export default function OrganizationLocationPin({ org }) {
    // const [hasIcon, setHasIcon] = React.useState(false);
    // const [srcImg, setSrcImg] = useState("");

    console.log(`OrganizationLocationPin org=`, org);
    let pinStyle = getPinStyle(org); // Use code to determine style, fallback to default if code is not recognized
    let hasIcon = org.pin_icon ? true : false;
    let srcImg = hasIcon ? `/assets/pin-icons/${org.pin_icon}.png` : "";
    console.log(`hasIcon=`, hasIcon, `srcImg=`, srcImg); 


    // const pinColor = hasIcon ? "transparent" : pinStyle.background;
    // console.log(`pinStyle=`, pinStyle);


    return (
        <>
            {hasIcon ? (
                <Box
                    component="img"
                    src={srcImg}
                    alt={org.name_en}
                    sx={{ width: 36, height: 36, objectFit: "contain" }}
                />
            ) : (
                <Pin
                    background={pinStyle.background}
                    borderColor={pinStyle.borderColor}
                    glyphColor={pinStyle.glyphColor}
                />
            )}
        </>
    );
}
